import type { JSX } from "react";
import type { Locale } from "@/i18n/config";

// Dil seçim menüsündeki ülke bayrakları.
//
// Emoji bayrak (🇹🇷) KULLANILMAZ: Windows'ta regional-indicator çifti bayrağa
// dönüşmez, iki harf olarak ("TR") çizilir — yani listenin yarısı bazı
// kullanıcılarda bayraksız kalırdı. Bu yüzden her bayrak inline SVG'dir;
// yazı tipinden ve platformdan bağımsız görünür.
//
// Bayrak DİLİN değil, dilin en yaygın bağlandığı ülkenin simgesidir (İngilizce
// için Birleşik Krallık). Bu yüzden ad her zaman bayrağın yanında durur —
// bayrak tek başına dil adı yerine geçmez.
//
// Ölçü: hepsi 24×16 viewBox'ta çizilir (gerçek bayrak oranları farklıdır; menüde
// tek tip dikdörtgen okunaklılığı korur). Beyaz zeminli bayraklar (fi, pl, nl…)
// açık temada arka planla birleşmesin diye ince bir currentColor çerçeve eklenir.

function Da() {
  return (
    <>
      <rect width="24" height="16" fill="#C8102E" />
      <rect y="6.4" width="24" height="3.2" fill="#fff" />
      <rect x="6.8" width="3.2" height="16" fill="#fff" />
    </>
  );
}

function De() {
  return (
    <>
      <rect width="24" height="16" fill="#000" />
      <rect y="5.33" width="24" height="5.34" fill="#DD0000" />
      <rect y="10.67" width="24" height="5.33" fill="#FFCE00" />
    </>
  );
}

function Gb() {
  return (
    <>
      <rect width="24" height="16" fill="#012169" />
      <path d="M0 0 24 16M24 0 0 16" fill="none" stroke="#fff" strokeWidth="3.4" />
      <path d="M0 0 24 16M24 0 0 16" fill="none" stroke="#C8102E" strokeWidth="1.8" />
      <path d="M12 0v16M0 8h24" fill="none" stroke="#fff" strokeWidth="5.4" />
      <path d="M12 0v16M0 8h24" fill="none" stroke="#C8102E" strokeWidth="3.2" />
    </>
  );
}

function Es() {
  return (
    <>
      <rect width="24" height="16" fill="#AA151B" />
      <rect y="4" width="24" height="8" fill="#F1BF00" />
    </>
  );
}

function Fr() {
  return (
    <>
      <rect width="24" height="16" fill="#fff" />
      <rect width="8" height="16" fill="#002395" />
      <rect x="16" width="8" height="16" fill="#ED2939" />
    </>
  );
}

function It() {
  return (
    <>
      <rect width="24" height="16" fill="#F4F5F0" />
      <rect width="8" height="16" fill="#008C45" />
      <rect x="16" width="8" height="16" fill="#CD212A" />
    </>
  );
}

function Nl() {
  return (
    <>
      <rect width="24" height="16" fill="#fff" />
      <rect width="24" height="5.33" fill="#AE1C28" />
      <rect y="10.67" width="24" height="5.33" fill="#21468B" />
    </>
  );
}

function Pl() {
  return (
    <>
      <rect width="24" height="16" fill="#fff" />
      <rect y="8" width="24" height="8" fill="#DC143C" />
    </>
  );
}

function Fi() {
  return (
    <>
      <rect width="24" height="16" fill="#fff" />
      <rect y="6" width="24" height="4" fill="#003580" />
      <rect x="6.5" width="4" height="16" fill="#003580" />
    </>
  );
}

function Tr() {
  return (
    <>
      <rect width="24" height="16" fill="#E30A17" />
      <circle cx="9.2" cy="8" r="3.5" fill="#fff" />
      <circle cx="10.6" cy="8" r="2.8" fill="#E30A17" />
      <path
        d="M14.6 6 15.05 7.38 16.5 7.38 15.33 8.24 15.78 9.62 14.6 8.76 13.42 9.62 13.87 8.24 12.7 7.38 14.15 7.38Z"
        fill="#fff"
      />
    </>
  );
}

function Ru() {
  return (
    <>
      <rect width="24" height="16" fill="#fff" />
      <rect y="5.33" width="24" height="5.34" fill="#0039A6" />
      <rect y="10.67" width="24" height="5.33" fill="#D52B1E" />
    </>
  );
}

function Cs() {
  return (
    <>
      <rect width="24" height="16" fill="#fff" />
      <rect y="8" width="24" height="8" fill="#D7141A" />
      <path d="M0 0 12 8 0 16Z" fill="#11457E" />
    </>
  );
}

function Hu() {
  return (
    <>
      <rect width="24" height="16" fill="#fff" />
      <rect width="24" height="5.33" fill="#CE2939" />
      <rect y="10.67" width="24" height="5.33" fill="#477050" />
    </>
  );
}

function No() {
  return (
    <>
      <rect width="24" height="16" fill="#BA0C2F" />
      <rect y="6" width="24" height="4" fill="#fff" />
      <rect x="6.55" width="4.36" height="16" fill="#fff" />
      <rect y="7" width="24" height="2" fill="#00205B" />
      <rect x="7.64" width="2.18" height="16" fill="#00205B" />
    </>
  );
}

function Pt() {
  return (
    <>
      <rect width="24" height="16" fill="#FF0000" />
      <rect width="9.6" height="16" fill="#006600" />
      <circle cx="9.6" cy="8" r="3.4" fill="none" stroke="#FFE000" strokeWidth="1.2" />
      <rect x="8.2" y="6.4" width="2.8" height="3.2" rx="0.6" fill="#fff" stroke="#FF0000" strokeWidth="0.7" />
    </>
  );
}

function Ro() {
  return (
    <>
      <rect width="24" height="16" fill="#FCD116" />
      <rect width="8" height="16" fill="#002B7F" />
      <rect x="16" width="8" height="16" fill="#CE1126" />
    </>
  );
}

function Sr() {
  return (
    <>
      <rect width="24" height="16" fill="#fff" />
      <rect width="24" height="5.33" fill="#C6363C" />
      <rect y="5.33" width="24" height="5.34" fill="#0C4076" />
    </>
  );
}

function Sv() {
  return (
    <>
      <rect width="24" height="16" fill="#006AA7" />
      <rect y="6.4" width="24" height="3.2" fill="#FECC02" />
      <rect x="7.5" width="3" height="16" fill="#FECC02" />
    </>
  );
}

function Bg() {
  return (
    <>
      <rect width="24" height="16" fill="#fff" />
      <rect y="5.33" width="24" height="5.34" fill="#00966E" />
      <rect y="10.67" width="24" height="5.33" fill="#D62612" />
    </>
  );
}

function Uk() {
  return (
    <>
      <rect width="24" height="16" fill="#0057B7" />
      <rect y="8" width="24" height="8" fill="#FFD700" />
    </>
  );
}

const FLAGS: Record<Locale, () => JSX.Element> = {
  cs: Cs,
  da: Da,
  de: De,
  en: Gb,
  es: Es,
  fr: Fr,
  it: It,
  hu: Hu,
  nl: Nl,
  no: No,
  pl: Pl,
  pt: Pt,
  ro: Ro,
  sr: Sr,
  fi: Fi,
  sv: Sv,
  tr: Tr,
  bg: Bg,
  ru: Ru,
  uk: Uk,
};

export default function Flag({ locale, className = "" }: { locale: Locale; className?: string }) {
  const Shape = FLAGS[locale];
  if (!Shape) return null;
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 24 16"
      // Köşe yuvarlatma clipPath ile değil border-radius ile: aynı menüde yirmi
      // bayrak var, paylaşılan bir SVG id'si belgede yirmi kez tekrarlanırdı.
      // <svg> zaten overflow:hidden olduğu için yarıçap içeriği de kırpar.
      className={`shrink-0 rounded-[3px] ${className}`}
      aria-hidden="true"
      focusable="false"
    >
      <Shape />
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="15"
        rx="2.5"
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.22"
      />
    </svg>
  );
}
